import lscache from 'lscache';
import React, {
  createContext,
  useContext,
  useEffect,
  useMemo,
  useReducer,
} from 'react';

import actionsFactory, { Currency } from './actionsFactory';

export type CurrenciesListState = {
  currencies: Currency[];
  loading: boolean;
  error: string | null;
};

const CURRENCIES_CACHE_KEY = 'CURRENCIES_LIST';

const initialState: CurrenciesListState = {
  currencies: lscache.get(CURRENCIES_CACHE_KEY) || [],
  loading: false,
  error: null,
};

function reducer(
  state: CurrenciesListState,
  action: { type: string; payload: any },
) {
  return { ...state, ...action.payload };
}

const initialContext = {
  state: initialState,
  actions: actionsFactory(() => {}),
};

const CurrenciesListContext = createContext(initialContext);
const useCurrenciesListContext = () => useContext(CurrenciesListContext);

function CurrenciesListContextProvider({
  children,
}: {
  children: React.ReactNode;
}) {
  const [state, dispatcher] = useReducer(reducer, initialState);
  const actions = useMemo(() => actionsFactory(dispatcher), [dispatcher]);

  useEffect(() => {
    actions.fetchCurrencies();
  }, [actions]);

  const contextValue = { state, actions };

  return (
    <CurrenciesListContext.Provider value={contextValue}>
      {children}
    </CurrenciesListContext.Provider>
  );
}

export { useCurrenciesListContext, CurrenciesListContextProvider };
